function getEffectivePixelRatio() {
  return Math.max(1, window.devicePixelRatio || 1)
}

function getResponsiveImageWidth() {
  const dpr = getEffectivePixelRatio()
  const screenWidth = Math.min(5120, window.innerWidth * dpr)
  const screenHeight = Math.min(5120, window.innerHeight * dpr)
  const widths = [720,1024,1280,1440,1600,1920,2048,2160,2560,2880,3200,3840,4096,5120]

  // En vertical usamos la altura como referencia, porque una imagen apaisada
  // con background-size: cover queda condicionada principalmente por ella.
  const target = screenWidth > screenHeight ? screenWidth : screenHeight

  return widths.find(width => width >= target) || 5120
}

function prepareImageContainer(imageContainer, imageUrl) {
  imageContainer.style.backgroundImage = 'url("/icons/loading9.gif")'
  imageContainer.style.backgroundSize = 'auto'
  imageContainer.style.backgroundPosition = 'center'
  imageContainer.style.backgroundRepeat = 'no-repeat'
  imageContainer.style.backgroundColor = '#000'
  imageContainer.dataset.sizedImage = imageUrl
}

export function loadImages() {
  const contactItem = document.querySelector('.contact-item')
  const projectItems = Array.from(document.querySelectorAll('.project-item'))
  const imagesWidth = getResponsiveImageWidth()

  if (contactItem && contactItem.dataset.image) {
    const contactImageWidth = Math.max(1600, imagesWidth)

    prepareImageContainer(
      contactItem,
      `/uploads/contact_page_setting/image/1/img${contactImageWidth}_${contactItem.dataset.image}`
    )
    return
  }

  projectItems.forEach(imageContainer => {
    const id = imageContainer.dataset.id
    const image = imageContainer.dataset.image

    if (!id || !image)
      return

    prepareImageContainer(
      imageContainer,
      `/uploads/project_item/image1/${id}/img${imagesWidth}_${image}`
    )
  })
}
